export default function ValorPlanos(props) {
    return( 
        <span>{props.valor}</span>
    );
}